import { Typography } from '@mui/material';
import React from 'react';

interface ActivityTimelineEntryTitleProps {
  title: string;
  authorName: string | null;
  variant?: 'body1' | 'body2';
  fontWeight?: number;
}

/** Activity label with optional inline author, e.g. "Lead created by Jane Doe". */
export const ActivityTimelineEntryTitle: React.FC<ActivityTimelineEntryTitleProps> = ({
  title,
  authorName,
  variant = 'body1',
  fontWeight = 700,
}) => (
  <Typography
    variant={variant}
    fontWeight={fontWeight}
    component="span"
    sx={{ minWidth: 0 }}
  >
    {title}
    {authorName ? (
      <>
        {' '}
        <Typography
          component="span"
          variant="inherit"
          fontWeight="inherit"
          color="primary.main"
        >
          by
        </Typography>{' '}
        <Typography
          component="span"
          variant="inherit"
          fontWeight="inherit"
          color="info.main"
          title={authorName}
        >
          {authorName}
        </Typography>
      </>
    ) : null}
  </Typography>
);

interface ActivityTimelineEntryDateProps {
  dateLabel: string;
}

export const ActivityTimelineEntryDate: React.FC<ActivityTimelineEntryDateProps> = ({
  dateLabel,
}) => (
  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
    {dateLabel}
  </Typography>
);
